import { Box, Image, ListItemSelect, Text } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext, ZIndexContext } from './../../ricos-context';
import { getScaleImageSrc } from './../../wix-rich-content-common/lib/imageUtils';

import type { ContentType } from '../constants';
import { convertDuration } from '../convertDuration';
import {
  INSERT_VERTICAL_EMBED_MODAL_ITEM,
  INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE,
} from '../data-hooks';
import type { EmbedItem } from '../types';

type ItemsListProps = {
  items: EmbedItem[];
  onClick: (item: EmbedItem) => void;
  selectedItem?: EmbedItem;
  contentType: ContentType;
  modalRef?: HTMLDivElement | null;
};

export const ItemsList: React.FC<ItemsListProps> = ({
  items,
  onClick,
  selectedItem,
  contentType,
  modalRef,
}) => {
  const { t, environment } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);

  if (items.length === 0) {
    return (
      <Box direction="vertical" margin="SP4" gap="SP2" textAlign="center">
        <Text size="medium" weight="bold" secondary>
          {t(`Embed_Vertical_${contentType}_EmptyState_NoItems_Title`)}
        </Text>
        <Text size="small" secondary>
          {t(`Embed_Vertical_${contentType}_EmptyState_NoItems_Description`)}
        </Text>
      </Box>
    );
  }

  if (!modalRef) {
    return null;
  }

  return (
    <>
      {items.map(item => {
        return (
          <ListItemSelect
            size="small"
            key={item.id}
            dataHook={INSERT_VERTICAL_EMBED_MODAL_ITEM}
            title={item.name}
            selected={selectedItem?.id === item.id}
            onClick={() => onClick(item)}
            ellipsis
            prefix={
              <Box width="50px" height="50px" margin="6px 6px 6px 0">
                <Image
                  src={item.imageSrc ? getScaleImageSrc(item.imageSrc, 50, 50) : undefined}
                  dataHook={INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE}
                  {...(environment === 'liveSite' ? { borderRadius: '0' } : {})}
                />
              </Box>
            }
            subtitle={
              contentType === 'Bookings'
                ? convertDuration(item.durations, t) || undefined
                : contentType === 'Events'
                ? `${item.scheduling} | ${item.location}`
                : undefined
            }
            tooltipProps={{
              appendTo: modalRef,
              zIndex: zIndexService.getZIndex('TOOLTIP'),
              children: [],
              enterDelay: 1000,
              placement: 'top',
            }}
          />
        );
      })}
    </>
  );
};
